import { makeObservable, observable } from 'mobx';

export class TokenStore {
  @observable
  token: string | null;

  constructor() {
    this.token = null;
    makeObservable(this);
  }

  setToken(token: string) {
    this.token = token;
  }
}
